import React from "react";

const SvgHelpIcon = props => (
  <svg viewBox="0 0 13.229 13.229" height="1em" width="1em" {...props}>
    <defs>
      <clipPath id="HelpIcon_svg__a" clipPathUnits="userSpaceOnUse">
        <path d="M0 42.353h26.135V0H0z" />
      </clipPath>
      <clipPath id="HelpIcon_svg__b" clipPathUnits="userSpaceOnUse">
        <path d="M0 42.353h26.135V0H0z" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#HelpIcon_svg__a)"
      transform="matrix(.29254 0 0 -.29254 2.855 12.762)"
    >
      <g clipPath="url(#HelpIcon_svg__b)" opacity={0.56}>
        <path
          d="M26.134 2.85A2.85 2.85 0 0 0 23.284 0H2.85A2.85 2.85 0 0 0 0 2.85v30.188a2.85 2.85 0 0 0 2.85 2.85h20.434a2.85 2.85 0 0 0 2.85-2.85z"
          fill="#010101"
        />
        <path
          d="M23.285 1.267H2.849c-.873 0-1.583.71-1.583 1.583v30.188c0 .874.71 1.583 1.583 1.583h20.436c.874 0 1.584-.71 1.584-1.583V2.85c0-.873-.71-1.583-1.584-1.583"
          fill="#fff"
        />
        <path
          d="M2.85 1.089c-.973 0-1.762.79-1.763 1.762v30.188c.001.971.79 1.76 1.762 1.76h20.436a1.763 1.763 0 0 0 1.761-1.76V2.85c0-.972-.79-1.762-1.76-1.762v.356A1.411 1.411 0 0 1 24.69 2.85v30.188a1.407 1.407 0 0 1-1.405 1.405H2.85a1.406 1.406 0 0 1-1.404-1.405V2.851a1.41 1.41 0 0 1 1.404-1.406h20.436v-.357z"
          fill="#010101"
        />
        <path
          d="M12.851 39.504c-4.747 0-8.622-2.736-8.855-6.175h17.71c-.233 3.439-4.109 6.175-8.855 6.175"
          fill="#010101"
        />
        <path
          d="M15.7 39.504a2.85 2.85 0 1 0-5.698-.002 2.85 2.85 0 0 0 5.699.002"
          fill="#010101"
        />
        <path
          d="M14.672 39.504a1.82 1.82 0 1 0-3.641 0 1.821 1.821 0 0 0 3.64 0"
          fill="#fff"
        />
        <path
          d="M3.548 23.593h5.913v6.463H3.548zm6.072-.158v.158zm-6.39-.158v7.096h6.548v-7.096zM3.548 13.881h5.913v6.464H3.548zm6.072-.158v.158zm-6.39-.159v7.097h6.548V13.564zM3.548 4.169h5.913v6.463H3.548zm6.072-.158v.158zm-6.39-.159v7.097h6.548V3.852z"
          fill="#010101"
        />
        <path
          d="M4.83 8.383a.633.633 0 1 0 .896.896L8.54 6.463l13.312 11.745a.633.633 0 1 0 .837-.95L8.486 4.725z"
          fill="#010101"
        />
      </g>
    </g>
  </svg>
);

export default SvgHelpIcon;

